















import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { signOut } from "../core/auth";

@Component
export default class Profile extends Vue {
  get email() {
    return this.$store.state.user?.email;
  }

  signOut() {
    signOut();
  }
}
